module.exports = __webpack_public_path__ + "img/SWP_Sword_1H_02 (1).ed6f145a.png";